import { MenuItem } from '@material-ui/core';
import { Select, SelectProps } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { SecondaryButton } from '../buttons';
import styled from 'styled-components';

interface DropdownItems {
    key: string;
    value: any;
}

interface IProps extends SelectProps {
    values: Array<any> | Array<DropdownItems>;
}

const useStyles = makeStyles({
    select: { paddingTop: '0px !important', paddingBottom: '0px !important', fontFamily: 'Work Sans' },
});

const StyledSelect = styled(Select)`
    .MuiOutlinedInput-notchedOutline {
        border-style: none !important;
    }
`;

export default function SecondaryButtonDropdown({ values, ...props }: IProps) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    function handleOpen() {
        setOpen(!open);
    }

    function instanceOfDropdownItems(object: any): object is DropdownItems {
        return object.key !== undefined;
    }

    return (
        <SecondaryButton onClick={handleOpen}>
            <StyledSelect classes={classes} open={open} style={{ width: '100%' }} {...props}>
                {values.map((val: DropdownItems) => {
                    if (instanceOfDropdownItems(val)) {
                        return <MenuItem value={val.value}>{val.key}</MenuItem>;
                    } else {
                        return <MenuItem value={val}>{val}</MenuItem>;
                    }
                })}
            </StyledSelect>
        </SecondaryButton>
    );
}
